<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    persistent
    transition="scale-transition"
  >
    <v-card dark color="black" tile height="100%">
      <v-app-bar app clipped-left color="transparent" width="100%" flat>
        <img
          alt="MetaPolis"
          src="../assets/metapolis-logox1-inverted.png"
          class="mt-1"
          style="width:160px"
        />
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <PhotoSocialShare :title="fullTitle" v-if="photo" />
          <v-btn @click="$emit('close', $route.params.slug)" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-app-bar>
      <div style="height:100vh" class="d-flex">
        <div class="d-flex pa-4 justify-center align-center">
          <v-btn
            v-if="previousImage && navVisible"
            @click="goToPreviousImage()"
            icon
            class="d-none d-md-block"
          >
            <v-icon size="48" color="grey">mdi-chevron-left</v-icon>
          </v-btn>
        </div>

        <div
          class="d-flex flex-grow-1 justify-center"
          style="position:relative"
        >
          <v-img
            v-if="photo"
            :src="src"
            :aspect-ratio="aspect"
            contain
            v-touch="{
              right: () => goToPreviousImage(),
              left: () => goToNextImage()
            }"
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  width="2"
                  color="blue lighten-4"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
        </div>
        <div class="d-flex pa-4 justify-center align-center">
          <v-btn
            v-if="nextImage && navVisible"
            @click="goToNextImage()"
            icon
            class="d-none d-md-block"
          >
            <v-icon size="48" color="grey">mdi-chevron-right</v-icon>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import PhotoSocialShare from "../components/PhotoSocialShare";

export default {
  name: "Photo",
  components: { PhotoSocialShare },
  data() {
    return {
      dialog: true,
      photo: null,
      series: null,
      logo: "https://stayingathome.metapolis.gr/images/metapolis.png"
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "title",
          content: `Metapolis | ${this.seriesName} | ${this.artistName} | Untitled`
        },
        // Twitter Card
        { name: "twitter:card", content: "METAPolis | Staying at home" },
        {
          name: "twitter:title",
          content: `${this.seriesName} | ${this.artistName} | Untitled`
        },
        {
          name: "twitter:description",
          content: "…η Μετάπολις είμαστε εμείς"
        },
        // image must be an absolute path
        { name: "twitter:image", content: this.logo },
        // Facebook OpenGraph
        {
          property: "og:title",
          content: `${this.seriesName} | ${this.artistName} | Untitled`
        },
        { property: "og:site_name", content: "METAPolis | Staying at home" },
        { property: "og:type", content: "website" },
        { property: "og:image", content: this.logo },
        {
          property: "og:description",
          content: "…η Μετάπολις είμαστε εμείς"
        }
      ]
    };
  },
  mounted() {
    this.setPhoto(this.$route.params.id);
    this.getSeries(this.$route.params.id);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
  computed: {
    fullTitle() {
      return this.artist
        ? `${this.artist.title}: ${this.title || "Untitled"}`
        : null;
    },
    navVisible() {
      //return this.info === false;
      return true;
    },
    artist() {
      return _.get(this.series, "artist");
    },
    seriesName() {
      return _.get(this.series, "name");
    },
    artistName() {
      return _.get(this.series, "artist.title");
    },
    aspect() {
      return this.width / this.height;
    },
    lazySrc() {
      return _.get(this.photo, "lazy");
    },
    src() {
      return _.get(this.photo, "src");
    },
    title() {
      return _.get(this.photo, "title");
    },
    descr() {
      return _.get(this.series, "description");
    },
    width() {
      return _.get(this.photo, "width", 1);
    },
    song() {
      return _.get(this.series, "song");
    },
    height() {
      return _.get(this.photo, "height", 1);
    },
    loading() {
      return !_.has(this.photo, "author");
    },
    nextImage() {
      const intId = parseInt(this.$route.params.id);
      return intId < this.$store.getters.maxId ? intId + 1 : null;
    },
    previousImage() {
      const intId = parseInt(this.$route.params.id);
      return intId > this.$store.getters.minId ? intId - 1 : null;
    }
  },
  methods: {
    swipe(direction) {
      console.log(direction);
    },
    setPhoto(id) {
      const photo = this.$store.getters.getPhotoById(id);
      this.photo = photo;
      this.series = _.get(this.getSeries(photo.id), 0);
    },
    getSeries(id) {
      const series = this.$store.state.series;
      return _.filter(series, function(ser) {
        for (let i = 0; i < ser.photos.length; i++) {
          if (ser.photos[i].id === id) {
            return ser;
          }
        }
      });
    },
    countDownTimer() {
      if (this.countDown > 0) {
        this.timeout = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    goToNextImage() {
      if (this.nextImage) {
        const next = this.$store.getters.getSeriesByPhotoId(this.nextImage);
        this.$router.push(`/artists/${next.slug}/images/${next.id}`);
        this.setPhoto(next.id);
      }
    },
    goToPreviousImage() {
      if (this.previousImage) {
        const prev = this.$store.getters.getSeriesByPhotoId(this.previousImage);
        console.log(prev);
        this.$router.push(`/artists/${prev.slug}/images/${prev.id}`);
        this.setPhoto(prev.id);
      }
    }
  }
};
</script>

<style scoped></style>
